import Select from 'react-select';
import { setCacheSearchType } from '../../redux/rulesSlice';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/styles.css';

export default function SearchType() {
    const { cacheSearchType } = useSelector(state => state.rules);
    const dispatch = useDispatch();
    const options = [
        { value: 'PartNumber', label: 'Part Number'},
        { value: 'WhereUse', label: 'Where Use' },
    ];

    const handleSearchTypeChange = (src) => {
        if (cacheSearchType != src)
        {
            dispatch(setCacheSearchType(src));
        }
    };

    return (
        <div className='flex items-center gap-4 flex-nowrap'>
            <span className='w-160'>
                <Select options={options}
                    value={options.find(x => x.value === cacheSearchType)}
                    onChange={(e) => handleSearchTypeChange(e.value)}
                />
            </span>
        </div>
    )
}